// extracted by mini-css-extract-plugin
export var downArrow = "_gd-0";
export var infoTooltipIcon = "_gd-3";
export var label = "_gd-1";
export var optionCard = "_gd-4";
export var upArrow = "_gd-2";